import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const ErrorPopup = ({
	text,
	style,
}) => (
	<span className="error-popup" style={style}>
		{text}
	</span>
);

ErrorPopup.propTypes = {
	text: PropTypes.string,
	style: PropTypes.object,
};

ErrorPopup.defaultProps = {
	text: '',
	style: {},
};

export default ErrorPopup;



// WEBPACK FOOTER //
// ./src/components/ui/Fields/ErrorPopup/index.js